import { z } from 'zod'
import api from 'features/common/transport'
import { ERROR_DEFAULT } from 'features/common/core/errors'
import { clearUserToken } from '../../../utils/token'
import { UserData, currencyByCountry } from 'features/common/core/entitites'

const userDataSchema = z.object({
    service_id: z.number(),
    email: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    organization: z.object({
        organization_id: z.number(),
        name: z.string(),
        country: z.literal('bg').or(z.literal('ro')),
        qr_id: z.string(),
        stripe_account_id: z.string(),
        stripe_product_id: z.string(),
    }),
    onboarding: z.object({
        completed: z.boolean(),
        next_action: z
            .object({
                id: z.string(),
                params: z
                    .object({
                        link: z.string().optional(),
                    })
                    .optional(),
            })
            .optional(),
    }),
})

const getUserData = async () => {
    const res = await api.get('users/me', { cache: 'no-cache' }).json()
    const parseRes = userDataSchema.safeParse(res)

    if (!parseRes.success) {
        clearUserToken()
        throw new Error(ERROR_DEFAULT)
    }

    const { service_id, email, first_name, organization, onboarding } =
        parseRes.data

    const {
        organization_id,
        name,
        country,
        qr_id,
        stripe_account_id,
        stripe_product_id,
    } = organization

    const currency = currencyByCountry[country]

    const userData: UserData = {
        id: service_id.toString(),
        email,
        name: first_name,
        organization: {
            organizationId: organization_id,
            name,
            country,
            qrId: qr_id,
            stripeAccountId: stripe_account_id,
            stripeProductId: stripe_product_id,
        },
        country,
        currency,
        phone: '111111111',
        onboarding,
    }

    return userData
}

export default getUserData
